import { render, staticRenderFns } from "./showSpeakerEdition.vue?vue&type=template&id=adb143f2"
import script from "./showSpeakerEdition.vue?vue&type=script&lang=js"
export * from "./showSpeakerEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports